import { array } from '@ember/helper';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';

import joinClasses from 'webapp/helpers/join-classes';
import visibleCheckItem from 'webapp/modifiers/visible-check-item';
import BoardImagePreviewComponent from 'webapp/components/board/image-preview';
import CommonUiIconComponent from 'webapp/components/common/ui-icon';
import DummyCellComponent from 'webapp/components/dummy-cell';
import EditableModelPropertyComponent from 'webapp/components/editable-model-property';
import FlexibleToggleCellComponent from 'webapp/components/flexible-toggle-cell';
import FormCheckboxComponent from 'webapp/components/form/checkbox';
import OptionsButtonComponent from 'webapp/components/options-button';
import OwnerSelectComponent from 'webapp/components/owner-select';
import ReportsIndexItemBaseComponent from 'webapp/components/reports/index/item-base';
import TagContainerComponent from 'webapp/components/tag-container';
import VerificationBadgeComponent from 'webapp/components/verification/badge';

export default class ReportsIndexTableRowComponent extends ReportsIndexItemBaseComponent {
	@tracked showAll = false;

	get canEdit(): boolean {
		return this.args.model.canCurrentUserEdit && !this.isDemoAccount;
	}

	get imageClickHandler() {
		if (this.isDeleted) {
			return;
		}
		return this.present;
	}

	@action
	toggleShowAll() {
		this.showAll = !this.showAll;
	}
	<template>
		{{#if this.isVisibleOnScreen}}

			<tr
				data-id={{@model.id}}
				class={{joinClasses
					(array
						"table-row"
						(if this.showAll "all-shown")
						(if @hideSort "hideSort")
						(if this.isSelected "selected")
					)
				}}
			>
				<td class="cc no-grow first">
					{{#unless this.isDemoAccount}}
						<div class="drag" data-id={{@model.id}}>
							<CommonUiIconComponent @name="ArrowsMove" @size="md" />
						</div>
					{{/unless}}

					<FormCheckboxComponent
						@name="reports-table-row"
						@selected={{this.isSelected}}
						@theme="blue"
						@onChange={{this.selectItem}}
					/>
				</td>

				<td class="c0 board no-grow">

					<BoardImagePreviewComponent
						@image={{@model.image}}
						@fallbackImage={{@model.fallbackImage}}
						@color={{@model.color}}
						@isLazyLoaded={{true}}
						@emblemTypeName={{this.emblemTypeName}}
						@onImageClick={{this.imageClickHandler}}
					/>

				</td>
				<td class="c1">
					<div class="flex">
						<EditableModelPropertyComponent
							@model={{@model}}
							@canEdit={{this.canEdit}}
							@editableProperty="title"
							@trackingObj={{this.trackingObj}}
						/>

						<VerificationBadgeComponent
							@verification={{@model.verificationInfo}}
							@entityLabel="report"
							@size="sm"
						/>

						<div class="labelicons">
							{{#if @model.favorite}}
								<span class="labelicon">
									<CommonUiIconComponent @name="StarFill" @size="sm" />
								</span>
							{{/if}}
						</div>
					</div>

					<small>by {{@model.createdByUser.name}} on {{@model.createdText}}</small>
				</td>

				<td class="c3 prio-low" data-label="Last edited: ">
					{{@model.modifiedText}}
				</td>

				<td class="c2 prio-medium" data-label="Owner: ">
					<OwnerSelectComponent
						@model={{@model}}
						@canEdit={{@model.canCurrentUserEdit}}
						@isOwnerNameHidden={{true}}
					/>
				</td>

				<td class="c4 prio-low" data-label="Tags: ">
					<TagContainerComponent
						@model={{@model}}
						@canEdit={{@model.canCurrentUserEdit}}
					/>
				</td>

				<td class="c6 button-ct last">
					<OptionsButtonComponent
						@options={{this.options}}
						@onAction={{this.doOptionsAction}}
					/>
				</td>

				<FlexibleToggleCellComponent
					@showAll={{this.showAll}}
					@toggleShowAll={{this.toggleShowAll}}
				/>
			</tr>
		{{else}}

			<tr data-id={{@model.id}} class="table-row" {{visibleCheckItem this.visibleChanged}}>
				<DummyCellComponent />
			</tr>

		{{/if}}
	</template>
}
